import { SPage } from 'servisofts-component2';

import root from './root';
// import feed from './feed';
// import datos from './datos';
// import paquetes from './paquetes';
// import asistencia from './asistencia';
// import progreso from './progreso';
// import editar from './editar';
// import gallery from './gallery';
// import gallery_confirm from './gallery_confirm';
// import camera from './camera';

export const Parent = {
  name: "perfil",
  path: "/perfil"
}
export default SPage.combinePages(Parent.name, {
  "": root,
  // feed,
  // datos,
  // paquetes,
  // asistencia,
  // progreso,
  // editar,
  // gallery,
  // "gallery/confirm": gallery_confirm,
  // camera
});